import { render } from "./toast-header.vue?vue&type=template&id=8d1b410a"
import script from "./toast-header.vue?vue&type=script&lang=js"
export * from "./toast-header.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__